import React from 'react';
import {
  CContainer, CRow, CCol, CCard, CCardBody, CCardHeader,
  CBreadcrumb, CBreadcrumbItem
} from '@coreui/react';
import { useNavigate } from 'react-router-dom';
import UnitInputs from '../../components/UnitInputs/UnitInputs';
import { connect } from 'react-redux';
import { createUnitRequestAction } from '../../store/unit/unitActions';
import { useTranslation } from '../../hooks/useTranslation';

const CreateUnit = ({ createUnitRequest, isLoading, createUnitData }) => {
  const navigate = useNavigate();
  const { t } = useTranslation();

  const handleSubmit = (data) => {
    createUnitRequest({ data, navigate });
  };

  const handleCancel = () => {
    navigate('/unit');
  };

  return (
    <CContainer>
      <CBreadcrumb className="mb-4">
        <CBreadcrumbItem href="#/unit" onClick={(e) => { e.preventDefault(); handleCancel(); }}>
          {t('units')}
        </CBreadcrumbItem>
        <CBreadcrumbItem active>{t('createUnit')}</CBreadcrumbItem>
      </CBreadcrumb>

      <CRow>
        <CCol xs={12}>
          <CCard>
            <CCardHeader><h4>{t('createUnit')}</h4></CCardHeader>
            <CCardBody>
              <UnitInputs
                onSubmit={handleSubmit}
                onCancel={handleCancel}
                isLoading={isLoading}
                submitResponse={createUnitData}
              />
            </CCardBody>
          </CCard>
        </CCol>
      </CRow>
    </CContainer>
  );
};

const mapStateToProps = (state) => ({
  isLoading: state.loadingReducer.isLoading,
  createUnitData: state.unitReducer.createUnitData,
});

const mapDispatchToProps = (dispatch) => ({
  createUnitRequest: (payload) => dispatch(createUnitRequestAction(payload)),
});

export default connect(mapStateToProps, mapDispatchToProps)(CreateUnit);
